import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricsPanel = ({ metrics }) => {
  const metricCards = [
    {
      title: 'Approval Rate',
      value: `${metrics?.approvalRate}%`,
      icon: 'TrendingUp',
      color: 'text-success',
      bgColor: 'bg-success/10',
      description: 'This month'
    },
    {
      title: 'Avg Response Time',
      value: `${metrics?.avgResponseTime}h`,
      icon: 'Clock',
      color: 'text-accent',
      bgColor: 'bg-accent/10',
      description: 'Hours to respond'
    },
    {
      title: 'Pending Feedback',
      value: metrics?.pendingCount,
      icon: 'AlertCircle',
      color: 'text-warning',
      bgColor: 'bg-warning/10',
      description: 'Awaiting response'
    },
    {
      title: 'Total Projects',
      value: metrics?.totalProjects,
      icon: 'Folder',
      color: 'text-foreground',
      bgColor: 'bg-muted',
      description: 'Active projects'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {metricCards?.map((metric, index) => (
        <div key={index} className="bg-card border border-border rounded-lg p-6 elevation-1">
          <div className="flex items-center justify-between mb-3">
            <div className={`w-10 h-10 rounded-lg ${metric?.bgColor} flex items-center justify-center`}>
              <Icon name={metric?.icon} size={20} className={metric?.color} />
            </div>
          </div>
          
          <div className="space-y-1">
            <p className="text-2xl font-heading text-foreground">{metric?.value}</p>
            <p className="text-sm font-medium text-foreground">{metric?.title}</p>
            <p className="text-xs text-muted-foreground">{metric?.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MetricsPanel;